<ul [ngClass]="{reverse : reverseDirection}">
    <li 
        *ngFor="let tab of tabs; let i = index" 
        (click)="selectTab(tab)" 
        [id]="'tab_' + tab?.pluginId"
        [class.active]="tab?.active"
    >
        <span class="tab-title">{{ tab.title }}</span>
        <span *ngIf="badges && badges[i]" class="tab-dot" aria-hidden="true"></span>
    </li>
</ul>
<div class="tab-content">
    <ng-content></ng-content>
</div>
